<template>
  <el-dialog
    fullscreen
    :title="`图片修改`"
    custom-class="cropper-dialog"
    :visible.sync="visible">
    <div style="display: flex;height: 100%;">
      <div style="height: 100%;width: calc(100% - 250px);">
        <CropperImage :url="lastUrl"
                      ref="cropperImage"/>
      </div>
      <div style="width: 250px;padding-left: 15px;">
        <el-form ref="form"
                 size="mini"
                 label-position="top">
          <el-form-item label="拍摄日期">
            <el-date-picker
              v-model="exif.datetime"
              type="datetime"
              format="yyyy:MM:dd HH:mm:ss"
              value-format="yyyy:MM:dd HH:mm:ss"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="拍摄经度">
            <el-input-number v-model="exif.gpsLongitude"
                             :min="-180"
                             :max="180"
                             :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="拍摄纬度">
            <el-input-number v-model="exif.gpsLatitude"
                             :min="-180"
                             :max="180"
                             :controls="false"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="onConfirm()">确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CropperImage from './CropperImage'
import piexif from 'piexifjs'
import PiexifHelper from './piexif-helper.js'
import { base64ToBlob, blobToBase64 } from 'base64-blob'

export default {
  mixins: [],
  components: {CropperImage},
  data () {
    return {
      url: null,
      callback: Function.prototype,
      visible: false,
      exif: {
        datetime: null,
        gpsLongitude: null,
        gpsLatitude: null,
      },
    }
  },
  computed: {
    lastUrl () {
      let url = filter.ossHost(this.url)
      this.readExif(url)
      return url
    }
  },
  watch: {
    visible (val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    async onConfirm () {
      let base64 = this.$refs.cropperImage.toDataURL()
      // 往图片中写入exif
      base64 = piexif.insert(piexif.dump(this.createExif()), base64)
      let blob = await base64ToBlob(base64)
      this.callback(blob, this.exif)
      this.visible = false
    },
    displayExif (exif) {
      let helper = new PiexifHelper(exif)
      this.exif.datetime = this.exif.datetime || helper.DateTimeOriginal() || helper.DateTime()
      this.exif.gpsLongitude = helper.GPSLongitude()
      this.exif.gpsLatitude = helper.GPSLatitude()
    },
    async readExif (url) {
      if (!url) return
      // 读取图片为 blob
      let {data: file} = await axios.create().get(url, {
        responseType: 'blob'
      })
      // 读取jpeg的exif信息
      if (file.type === 'image/jpeg') {
        let exif = piexif.load(await blobToBase64(file))
        this.displayExif(exif)
      }
    },
    createExif () {
      let helper = new PiexifHelper()
      helper.DateTimeOriginal(this.exif.datetime)
      helper.DateTime(this.exif.datetime)
      helper.GPSLongitude(this.exif.gpsLongitude)
      helper.GPSLatitude(this.exif.gpsLatitude)
      return helper.exif
    }
  },
}
</script>

<style lang="scss">
.cropper-dialog {
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 15px;
    height: calc(100% - 139px);
    overflow: auto;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/CropperImage/src/main.vue